import { useState } from "react";
import { Switch, Modal, Button, Text, Group } from "@mantine/core";
import { usePatchSurvey } from "../../api/survey";

export default function SwitchSurvey({
  surveyId,
  checked,
  numOfQuestions,
  onChange,
}) {
  const { mutate } = usePatchSurvey(surveyId);
  const [modalOpened, setModalOpened] = useState(false);
  const [nextState, setNextState] = useState(checked);

  const handleChange = (event) => {
    const newChecked = event.currentTarget.checked;

    if (newChecked && numOfQuestions === 0) {
      setNextState(true);
      setModalOpened(true);
      return;
    }

    setNextState(newChecked);
    setModalOpened(true);
  };

  const confirmChange = () => {
    mutate({ isLive: nextState });
    onChange({ currentTarget: { checked: nextState } });
    setModalOpened(false);
  };

  const cancelChange = () => {
    setModalOpened(false);
  };

  const hasNoQuestions = numOfQuestions === 0 && nextState;

  let modalTitle = "Confirm change";
  let modalMessage =
    "Once you set this survey as not live, questions that already have responses will no longer be editable.";

  if (hasNoQuestions) {
    modalTitle = "Cannot set survey live";
    modalMessage =
      "You cannot set this survey as live because it has no questions. Please add at least one question before making it live.";
  } else if (nextState) {
    modalMessage =
      "Once you set this survey as live, you will no longer be able to edit questions.";
  }

  return (
    <>
      <Switch color="green" checked={checked} onChange={handleChange} />

      <Modal
        opened={modalOpened}
        onClose={cancelChange}
        title={modalTitle}
        centered
      >
        <Text>{modalMessage}</Text>

        {hasNoQuestions && (
          <Group mt="md" justify="flex-end">
            <Button onClick={cancelChange}>OK</Button>
          </Group>
        )}

        {!hasNoQuestions && (
          <Group mt="md" justify="flex-end">
            <Button variant="outline" onClick={cancelChange}>
              Cancel
            </Button>
            <Button onClick={confirmChange}>Confirm</Button>
          </Group>
        )}
      </Modal>
    </>
  );
}
